// extracted by mini-css-extract-plugin
export default {"card":"ProjectCard_card__A5s99","content":"ProjectCard_content__PsHGD","tags":"ProjectCard_tags__01Pqy","cta":"ProjectCard_cta__-Irlq","underline":"ProjectCard_underline__kLUtM"};